import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) return navigate("/", { replace: true });
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data?.session_token) localStorage.setItem("pulse_session_token", data.session_token);
        // Full page load to /feed so AuthContext re-inits with the fresh Bearer token
        // in localStorage. This eliminates a race between setUser() and navigate() that
        // could briefly leave user=null while ProtectedRoute rendered → bouncing back
        // to landing (the "verifying → back to landing" loop).
        window.location.replace("/feed");
      } catch {
        window.location.replace("/");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white">
      <div className="surface rounded-md px-6 py-4 flex items-center gap-3">
        <div className="w-2 h-2 rounded-full bg-[#00E676] pulse-dot" />
        <span className="font-mono text-sm">Verifying session…</span>
      </div>
    </div>
  );
}
